// -----------------------------------------------------------------------------
// Ovolaay Hub — Central brand configuration (frontend fallback).
// The live values are served by GET /api/brand. This object is the default used
// while the request is loading or if the backend is unreachable.
// Change the platform identity (name, logo, colours, currency…) HERE and in the
// backend BRAND dict — never inside components.
// -----------------------------------------------------------------------------
export const defaultBrand = {
  name: "Ovolaay Hub",
  tagline: "La marketplace avicole du Mali",
  description:
    "Achetez et vendez facilement des poulets et des œufs frais partout au Mali — en toute confiance, sans intermédiaire.",
  logoUrl:
    "https://static.prod-images.emergentagent.com/jobs/643c140f-97bc-4114-97ee-77b119d84dac/images/5dc20f274ac361157911580b32740ce8d6da8c2845e7557845f355143c1258f0.jpeg",
  faviconUrl:
    "https://static.prod-images.emergentagent.com/jobs/643c140f-97bc-4114-97ee-77b119d84dac/images/5dc20f274ac361157911580b32740ce8d6da8c2845e7557845f355143c1258f0.jpeg",
  colors: {
    primary: "215 42% 42%",
    primaryForeground: "0 0% 100%",
    secondary: "220 16% 16%",
    secondaryForeground: "0 0% 100%",
    accent: "220 14% 94%",
    accentForeground: "220 16% 16%",
    success: "144 45% 24%",
    successForeground: "0 0% 100%",
    background: "0 0% 100%",
    foreground: "220 16% 16%",
  },
  contact: {
    email: "contact@ovolaay-hub.com",
    phone: "+223 00 00 00 00",
    whatsapp: "+223 00 00 00 00",
    address: "Bamako, Mali",
  },
  community: "https://whatsapp.com/channel/0029VbDA4vmKmCPUiMPDUz2f",
  support: "https://wa.me/33627164829",
  deliveryHours: "7h – 20h",
  social: {
    facebook: "https://facebook.com/ovolaayhub",
    instagram: "https://instagram.com/ovolaayhub",
    twitter: "https://twitter.com/ovolaayhub",
  },
  currency: "XOF",
  currencySymbol: "FCFA",
  region: "Mali",
  country: "Mali",
  locale: "fr",
};
